import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';

 /** A router wrapper, adding extra functions. */

@Injectable({
  providedIn: 'root'
})
export class RouterExtService {

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  private textUrl: string = undefined;
  private exploreBrudcrumb: any = [];

  constructor(private router: Router) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if(this.previousUrl.indexOf('searchlist') >= 0){
          this.previousUrl = '/recentlist/list';
        }
      }
    });
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  public setTextUrl(urlTxt) {
    this.textUrl = urlTxt;
  }
  public getTextUrl() {
    return this.textUrl;
  }

  public setExploreBreadcrumb(brudcrumb){
      this.exploreBrudcrumb =  brudcrumb;  
  }

  public getExploreBreadcrumb(){
      return this.exploreBrudcrumb;
  }
}